import { render, staticRenderFns } from "./ManageRatio.vue?vue&type=template&id=b6b1547e"
import script from "./ManageRatio.vue?vue&type=script&lang=js"
export * from "./ManageRatio.vue?vue&type=script&lang=js"
import style0 from "./ManageRatio.vue?vue&type=style&index=0&id=b6b1547e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports